// extracted by mini-css-extract-plugin
export default {"headerHeight":"AppLayout_headerHeight__kYfJC","content":"AppLayout_content__pnnWo"};